/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'actions-formatting-rotate-clockwise-alt': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" d="M10 18.75H2.5c-.69 0-1.25-.56-1.25-1.25V10c0-.69.56-1.25 1.25-1.25H10c.69 0 1.25.56 1.25 1.25v7.5c0 .69-.56 1.25-1.25 1.25zM2.5 10v7.5H10V10H2.5zm16.25-.625l-.881-.881-1.619 1.612V6.875A4.38 4.38 0 0011.875 2.5H8.75v1.25h3.125A3.129 3.129 0 0115 6.875v3.231l-1.619-1.612-.881.881 3.125 3.125 3.125-3.125z"/>'
  }
})
